// source: wisetime/user/assistant/v4/preferences.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var wisetime_user_assistant_v4_assistant_pb = require('../../../../wisetime/user/assistant/v4/assistant_pb.js');
goog.object.extend(proto, wisetime_user_assistant_v4_assistant_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.NarrateLength', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.NarratePreferences', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.Tense', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.TrainingGroup', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.TrainingNarrative', null, global);
goog.exportSymbol('proto.wisetime.user.assistant.v4.TrainingRow', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.displayName = 'proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.NarratePreferences = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.NarratePreferences, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.NarratePreferences.displayName = 'proto.wisetime.user.assistant.v4.NarratePreferences';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.displayName = 'proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.displayName = 'proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.TrainingGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.assistant.v4.TrainingGroup.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.TrainingGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.TrainingGroup.displayName = 'proto.wisetime.user.assistant.v4.TrainingGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.TrainingRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.TrainingRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.TrainingRow.displayName = 'proto.wisetime.user.assistant.v4.TrainingRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.displayName = 'proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.assistant.v4.TrainingNarrative = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.assistant.v4.TrainingNarrative, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.assistant.v4.TrainingNarrative.displayName = 'proto.wisetime.user.assistant.v4.TrainingNarrative';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    preferences: (f = msg.getPreferences()) && proto.wisetime.user.assistant.v4.NarratePreferences.toObject(includeInstance, f),
    trainingNarrativesList: jspb.Message.toObjectList(msg.getTrainingNarrativesList(),
    proto.wisetime.user.assistant.v4.TrainingNarrative.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest}
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest;
  return proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest}
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.assistant.v4.NarratePreferences;
      reader.readMessage(value,proto.wisetime.user.assistant.v4.NarratePreferences.deserializeBinaryFromReader);
      msg.setPreferences(value);
      break;
    case 5:
      var value = new proto.wisetime.user.assistant.v4.TrainingNarrative;
      reader.readMessage(value,proto.wisetime.user.assistant.v4.TrainingNarrative.deserializeBinaryFromReader);
      msg.addTrainingNarratives(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreferences();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wisetime.user.assistant.v4.NarratePreferences.serializeBinaryToWriter
    );
  }
  f = message.getTrainingNarrativesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.wisetime.user.assistant.v4.TrainingNarrative.serializeBinaryToWriter
    );
  }
};


/**
 * optional NarratePreferences preferences = 1;
 * @return {?proto.wisetime.user.assistant.v4.NarratePreferences}
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.prototype.getPreferences = function() {
  return /** @type{?proto.wisetime.user.assistant.v4.NarratePreferences} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.assistant.v4.NarratePreferences, 1));
};


/**
 * @param {?proto.wisetime.user.assistant.v4.NarratePreferences|undefined} value
 * @return {!proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest} returns this
*/
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.prototype.setPreferences = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest} returns this
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.prototype.clearPreferences = function() {
  return this.setPreferences(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.prototype.hasPreferences = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TrainingNarrative training_narratives = 5;
 * @return {!Array<!proto.wisetime.user.assistant.v4.TrainingNarrative>}
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.prototype.getTrainingNarrativesList = function() {
  return /** @type{!Array<!proto.wisetime.user.assistant.v4.TrainingNarrative>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.assistant.v4.TrainingNarrative, 5));
};


/**
 * @param {!Array<!proto.wisetime.user.assistant.v4.TrainingNarrative>} value
 * @return {!proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest} returns this
*/
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.prototype.setTrainingNarrativesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.wisetime.user.assistant.v4.TrainingNarrative=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.assistant.v4.TrainingNarrative}
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.prototype.addTrainingNarratives = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.wisetime.user.assistant.v4.TrainingNarrative, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest} returns this
 */
proto.wisetime.user.assistant.v4.SetNarratePreferencesRequest.prototype.clearTrainingNarrativesList = function() {
  return this.setTrainingNarrativesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.NarratePreferences.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.NarratePreferences} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.NarratePreferences.toObject = function(includeInstance, msg) {
  var f, obj = {
    narrateLength: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tense: jspb.Message.getFieldWithDefault(msg, 2, 0),
    language: jspb.Message.getFieldWithDefault(msg, 3, 0),
    customPrompt: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.NarratePreferences}
 */
proto.wisetime.user.assistant.v4.NarratePreferences.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.NarratePreferences;
  return proto.wisetime.user.assistant.v4.NarratePreferences.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.NarratePreferences} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.NarratePreferences}
 */
proto.wisetime.user.assistant.v4.NarratePreferences.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.wisetime.user.assistant.v4.NarrateLength} */ (reader.readEnum());
      msg.setNarrateLength(value);
      break;
    case 2:
      var value = /** @type {!proto.wisetime.user.assistant.v4.Tense} */ (reader.readEnum());
      msg.setTense(value);
      break;
    case 3:
      var value = /** @type {!proto.wisetime.user.assistant.v4.TranslateLanguage} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomPrompt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.NarratePreferences.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.NarratePreferences} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.NarratePreferences.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNarrateLength();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTense();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {!proto.wisetime.user.assistant.v4.TranslateLanguage} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional NarrateLength narrate_length = 1;
 * @return {!proto.wisetime.user.assistant.v4.NarrateLength}
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.getNarrateLength = function() {
  return /** @type {!proto.wisetime.user.assistant.v4.NarrateLength} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.wisetime.user.assistant.v4.NarrateLength} value
 * @return {!proto.wisetime.user.assistant.v4.NarratePreferences} returns this
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.setNarrateLength = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Tense tense = 2;
 * @return {!proto.wisetime.user.assistant.v4.Tense}
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.getTense = function() {
  return /** @type {!proto.wisetime.user.assistant.v4.Tense} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.wisetime.user.assistant.v4.Tense} value
 * @return {!proto.wisetime.user.assistant.v4.NarratePreferences} returns this
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.setTense = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional TranslateLanguage language = 3;
 * @return {!proto.wisetime.user.assistant.v4.TranslateLanguage}
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.getLanguage = function() {
  return /** @type {!proto.wisetime.user.assistant.v4.TranslateLanguage} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.wisetime.user.assistant.v4.TranslateLanguage} value
 * @return {!proto.wisetime.user.assistant.v4.NarratePreferences} returns this
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.setLanguage = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.assistant.v4.NarratePreferences} returns this
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.clearLanguage = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.hasLanguage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string custom_prompt = 4;
 * @return {string}
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.getCustomPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.assistant.v4.NarratePreferences} returns this
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.setCustomPrompt = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.assistant.v4.NarratePreferences} returns this
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.clearCustomPrompt = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.assistant.v4.NarratePreferences.prototype.hasCustomPrompt = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    count: jspb.Message.getFieldWithDefault(msg, 1, 0),
    excludeTrainingGroupIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest;
  return proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addExcludeTrainingGroupIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getExcludeTrainingGroupIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional uint32 count = 1;
 * @return {number}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest} returns this
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated string exclude_training_group_ids = 2;
 * @return {!Array<string>}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.prototype.getExcludeTrainingGroupIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest} returns this
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.prototype.setExcludeTrainingGroupIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest} returns this
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.prototype.addExcludeTrainingGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest} returns this
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsRequest.prototype.clearExcludeTrainingGroupIdsList = function() {
  return this.setExcludeTrainingGroupIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    trainingGroupsList: jspb.Message.toObjectList(msg.getTrainingGroupsList(),
    proto.wisetime.user.assistant.v4.TrainingGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse;
  return proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.assistant.v4.TrainingGroup;
      reader.readMessage(value,proto.wisetime.user.assistant.v4.TrainingGroup.deserializeBinaryFromReader);
      msg.addTrainingGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainingGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.assistant.v4.TrainingGroup.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TrainingGroup training_groups = 1;
 * @return {!Array<!proto.wisetime.user.assistant.v4.TrainingGroup>}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.prototype.getTrainingGroupsList = function() {
  return /** @type{!Array<!proto.wisetime.user.assistant.v4.TrainingGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.assistant.v4.TrainingGroup, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.assistant.v4.TrainingGroup>} value
 * @return {!proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse} returns this
*/
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.prototype.setTrainingGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.assistant.v4.TrainingGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.assistant.v4.TrainingGroup}
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.prototype.addTrainingGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.assistant.v4.TrainingGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse} returns this
 */
proto.wisetime.user.assistant.v4.ListTrainingGroupsResponse.prototype.clearTrainingGroupsList = function() {
  return this.setTrainingGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.assistant.v4.TrainingGroup.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.TrainingGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.TrainingGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.TrainingGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.TrainingGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rowsList: jspb.Message.toObjectList(msg.getRowsList(),
    proto.wisetime.user.assistant.v4.TrainingRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.TrainingGroup}
 */
proto.wisetime.user.assistant.v4.TrainingGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.TrainingGroup;
  return proto.wisetime.user.assistant.v4.TrainingGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.TrainingGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.TrainingGroup}
 */
proto.wisetime.user.assistant.v4.TrainingGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.wisetime.user.assistant.v4.TrainingRow;
      reader.readMessage(value,proto.wisetime.user.assistant.v4.TrainingRow.deserializeBinaryFromReader);
      msg.addRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.TrainingGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.TrainingGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.TrainingGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.TrainingGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.wisetime.user.assistant.v4.TrainingRow.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.wisetime.user.assistant.v4.TrainingGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.assistant.v4.TrainingGroup} returns this
 */
proto.wisetime.user.assistant.v4.TrainingGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated TrainingRow rows = 2;
 * @return {!Array<!proto.wisetime.user.assistant.v4.TrainingRow>}
 */
proto.wisetime.user.assistant.v4.TrainingGroup.prototype.getRowsList = function() {
  return /** @type{!Array<!proto.wisetime.user.assistant.v4.TrainingRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.assistant.v4.TrainingRow, 2));
};


/**
 * @param {!Array<!proto.wisetime.user.assistant.v4.TrainingRow>} value
 * @return {!proto.wisetime.user.assistant.v4.TrainingGroup} returns this
*/
proto.wisetime.user.assistant.v4.TrainingGroup.prototype.setRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.wisetime.user.assistant.v4.TrainingRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.assistant.v4.TrainingRow}
 */
proto.wisetime.user.assistant.v4.TrainingGroup.prototype.addRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.wisetime.user.assistant.v4.TrainingRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.assistant.v4.TrainingGroup} returns this
 */
proto.wisetime.user.assistant.v4.TrainingGroup.prototype.clearRowsList = function() {
  return this.setRowsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.TrainingRow.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.TrainingRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.TrainingRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.TrainingRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    appName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    windowTitle: jspb.Message.getFieldWithDefault(msg, 2, ""),
    iconUrl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.TrainingRow}
 */
proto.wisetime.user.assistant.v4.TrainingRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.TrainingRow;
  return proto.wisetime.user.assistant.v4.TrainingRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.TrainingRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.TrainingRow}
 */
proto.wisetime.user.assistant.v4.TrainingRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWindowTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIconUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.TrainingRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.TrainingRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.TrainingRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.TrainingRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWindowTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIconUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string app_name = 1;
 * @return {string}
 */
proto.wisetime.user.assistant.v4.TrainingRow.prototype.getAppName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.assistant.v4.TrainingRow} returns this
 */
proto.wisetime.user.assistant.v4.TrainingRow.prototype.setAppName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string window_title = 2;
 * @return {string}
 */
proto.wisetime.user.assistant.v4.TrainingRow.prototype.getWindowTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.assistant.v4.TrainingRow} returns this
 */
proto.wisetime.user.assistant.v4.TrainingRow.prototype.setWindowTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string icon_url = 3;
 * @return {string}
 */
proto.wisetime.user.assistant.v4.TrainingRow.prototype.getIconUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.assistant.v4.TrainingRow} returns this
 */
proto.wisetime.user.assistant.v4.TrainingRow.prototype.setIconUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    preferences: (f = msg.getPreferences()) && proto.wisetime.user.assistant.v4.NarratePreferences.toObject(includeInstance, f),
    trainingGroup: (f = msg.getTrainingGroup()) && proto.wisetime.user.assistant.v4.TrainingGroup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest}
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest;
  return proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest}
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.assistant.v4.NarratePreferences;
      reader.readMessage(value,proto.wisetime.user.assistant.v4.NarratePreferences.deserializeBinaryFromReader);
      msg.setPreferences(value);
      break;
    case 2:
      var value = new proto.wisetime.user.assistant.v4.TrainingGroup;
      reader.readMessage(value,proto.wisetime.user.assistant.v4.TrainingGroup.deserializeBinaryFromReader);
      msg.setTrainingGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreferences();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wisetime.user.assistant.v4.NarratePreferences.serializeBinaryToWriter
    );
  }
  f = message.getTrainingGroup();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.wisetime.user.assistant.v4.TrainingGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional NarratePreferences preferences = 1;
 * @return {?proto.wisetime.user.assistant.v4.NarratePreferences}
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.prototype.getPreferences = function() {
  return /** @type{?proto.wisetime.user.assistant.v4.NarratePreferences} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.assistant.v4.NarratePreferences, 1));
};


/**
 * @param {?proto.wisetime.user.assistant.v4.NarratePreferences|undefined} value
 * @return {!proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest} returns this
*/
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.prototype.setPreferences = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest} returns this
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.prototype.clearPreferences = function() {
  return this.setPreferences(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.prototype.hasPreferences = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TrainingGroup training_group = 2;
 * @return {?proto.wisetime.user.assistant.v4.TrainingGroup}
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.prototype.getTrainingGroup = function() {
  return /** @type{?proto.wisetime.user.assistant.v4.TrainingGroup} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.assistant.v4.TrainingGroup, 2));
};


/**
 * @param {?proto.wisetime.user.assistant.v4.TrainingGroup|undefined} value
 * @return {!proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest} returns this
*/
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.prototype.setTrainingGroup = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest} returns this
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.prototype.clearTrainingGroup = function() {
  return this.setTrainingGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.assistant.v4.GetTrainingNarrativeRequest.prototype.hasTrainingGroup = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.assistant.v4.TrainingNarrative.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.assistant.v4.TrainingNarrative.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.assistant.v4.TrainingNarrative} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.TrainingNarrative.toObject = function(includeInstance, msg) {
  var f, obj = {
    trainingGroup: (f = msg.getTrainingGroup()) && proto.wisetime.user.assistant.v4.TrainingGroup.toObject(includeInstance, f),
    narrative: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.assistant.v4.TrainingNarrative}
 */
proto.wisetime.user.assistant.v4.TrainingNarrative.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.assistant.v4.TrainingNarrative;
  return proto.wisetime.user.assistant.v4.TrainingNarrative.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.assistant.v4.TrainingNarrative} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.assistant.v4.TrainingNarrative}
 */
proto.wisetime.user.assistant.v4.TrainingNarrative.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.assistant.v4.TrainingGroup;
      reader.readMessage(value,proto.wisetime.user.assistant.v4.TrainingGroup.deserializeBinaryFromReader);
      msg.setTrainingGroup(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNarrative(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.assistant.v4.TrainingNarrative.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.assistant.v4.TrainingNarrative.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.assistant.v4.TrainingNarrative} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.assistant.v4.TrainingNarrative.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainingGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wisetime.user.assistant.v4.TrainingGroup.serializeBinaryToWriter
    );
  }
  f = message.getNarrative();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional TrainingGroup training_group = 1;
 * @return {?proto.wisetime.user.assistant.v4.TrainingGroup}
 */
proto.wisetime.user.assistant.v4.TrainingNarrative.prototype.getTrainingGroup = function() {
  return /** @type{?proto.wisetime.user.assistant.v4.TrainingGroup} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.assistant.v4.TrainingGroup, 1));
};


/**
 * @param {?proto.wisetime.user.assistant.v4.TrainingGroup|undefined} value
 * @return {!proto.wisetime.user.assistant.v4.TrainingNarrative} returns this
*/
proto.wisetime.user.assistant.v4.TrainingNarrative.prototype.setTrainingGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.assistant.v4.TrainingNarrative} returns this
 */
proto.wisetime.user.assistant.v4.TrainingNarrative.prototype.clearTrainingGroup = function() {
  return this.setTrainingGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.assistant.v4.TrainingNarrative.prototype.hasTrainingGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string narrative = 2;
 * @return {string}
 */
proto.wisetime.user.assistant.v4.TrainingNarrative.prototype.getNarrative = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.assistant.v4.TrainingNarrative} returns this
 */
proto.wisetime.user.assistant.v4.TrainingNarrative.prototype.setNarrative = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.wisetime.user.assistant.v4.NarrateLength = {
  NARRATE_LENGTH_UNSPECIFIED: 0,
  SHORT: 1,
  STANDARD: 2,
  LONG: 3
};

/**
 * @enum {number}
 */
proto.wisetime.user.assistant.v4.Tense = {
  TENSE_UNSPECIFIED: 0,
  PAST: 1,
  PRESENT: 2
};

goog.object.extend(exports, proto.wisetime.user.assistant.v4);
